/***** SIZE CHART MEASUREMENT SWITCH TOGGLE *****/ 
  
// 01 - get all the elements with the class size-chart-units  
var sizingElements = document.getElementsByClassName("size-chart-units");
// console.log("loaded");

// 03 - get the element clicked and its parent node, then call the needed functions to
//    - change the unit display and the unit measeurements themselves
var onSizingClick = function() {

    var attribute = this;
    var parentAttribute = this.parentNode;
    
    // this IF makes sure that the functions aren't called if the clicked measurement is already selected
    if(!attribute.classList.contains("size-selected")) {
    	toggleSize(parentAttribute);
		convertMeasurements(parentAttribute, attribute);
    }
    
};

// 02 - add a click event listener to each item and call the onSizingClick function when clicked
for(var i=0; i<sizingElements.length; i++){
    sizingElements[i].addEventListener('click', onSizingClick, false);
}

// 04 - swap the .size-selected class to get the background-color to change
function toggleSize(parentAttribute) {

	var childNodes = parentAttribute.children;

	for(var i=0; i<childNodes.length; i++){
    	childNodes[i].classList.toggle("size-selected");
	}

}

// 05 - swap the .size-selected class to get the background-color to change
function convertMeasurements(parentAttribute, attribute) {
    
    chartContainer = parentAttribute.nextElementSibling;
  
	// mens jersey sizing 	
    if(chartContainer.classList.contains("mens-jersey")){
		if(attribute.innerText == "IN") {
            chartContainer.getElementsByClassName("chest-measurement-xsmall")[0].innerHTML = "34.6 - 36.2";
			chartContainer.getElementsByClassName("chest-measurement-small")[0].innerHTML = "36.2 - 37.8";
			chartContainer.getElementsByClassName("chest-measurement-medium")[0].innerHTML = "37.8 - 39.4";
			chartContainer.getElementsByClassName("chest-measurement-large")[0].innerHTML = "39.4 - 40.9";
			chartContainer.getElementsByClassName("chest-measurement-xlarge")[0].innerHTML = "40.9 - 42.5";
			chartContainer.getElementsByClassName("chest-measurement-xxlarge")[0].innerHTML = "42.5 - 44";

			chartContainer.getElementsByClassName("waist-measurement-xsmall")[0].innerHTML = "29.1 - 30.7";
			chartContainer.getElementsByClassName("waist-measurement-small")[0].innerHTML = "30.7 - 32.2";
			chartContainer.getElementsByClassName("waist-measurement-medium")[0].innerHTML = "32.2 - 33.8";
			chartContainer.getElementsByClassName("waist-measurement-large")[0].innerHTML = "33.8 - 35.4";
			chartContainer.getElementsByClassName("waist-measurement-xlarge")[0].innerHTML = "35.4 - 37";
			chartContainer.getElementsByClassName("waist-measurement-xxlarge")[0].innerHTML = "37 - 38.6";
		} else {
			chartContainer.getElementsByClassName("chest-measurement-xsmall")[0].innerHTML = "88 - 92";
			chartContainer.getElementsByClassName("chest-measurement-small")[0].innerHTML = "92 - 96";
			chartContainer.getElementsByClassName("chest-measurement-medium")[0].innerHTML = "96 - 100";
			chartContainer.getElementsByClassName("chest-measurement-large")[0].innerHTML = "100 - 104";
			chartContainer.getElementsByClassName("chest-measurement-xlarge")[0].innerHTML = "104 - 108";
			chartContainer.getElementsByClassName("chest-measurement-xxlarge")[0].innerHTML = "108 - 112";

			chartContainer.getElementsByClassName("waist-measurement-xsmall")[0].innerHTML = "74 - 78";
			chartContainer.getElementsByClassName("waist-measurement-small")[0].innerHTML = "78 - 82";
			chartContainer.getElementsByClassName("waist-measurement-medium")[0].innerHTML = "82 - 86";
			chartContainer.getElementsByClassName("waist-measurement-large")[0].innerHTML = "86 - 90";
			chartContainer.getElementsByClassName("waist-measurement-xlarge")[0].innerHTML = "90 - 94";
			chartContainer.getElementsByClassName("waist-measurement-xxlarge")[0].innerHTML = "94 - 98";
		}
	// mens bibs sizing 	
	} else if(chartContainer.classList.contains("mens-bibs")){
		if(attribute.innerText == "IN") {
			chartContainer.getElementsByClassName("chest-measurement-xsmall")[0].innerHTML = "29.1 - 30.7";
			chartContainer.getElementsByClassName("chest-measurement-small")[0].innerHTML = "30.7 - 32.2";
			chartContainer.getElementsByClassName("chest-measurement-medium")[0].innerHTML = "32.2 - 33.8";
			chartContainer.getElementsByClassName("chest-measurement-large")[0].innerHTML = "33.8 - 35.4";
			chartContainer.getElementsByClassName("chest-measurement-xlarge")[0].innerHTML = "35.4 - 37";
			chartContainer.getElementsByClassName("chest-measurement-xxlarge")[0].innerHTML = "37 - 38.6";

			chartContainer.getElementsByClassName("waist-measurement-xsmall")[0].innerHTML = "7.8 - 8.2";
			chartContainer.getElementsByClassName("waist-measurement-small")[0].innerHTML = "8.2 - 8.6";
			chartContainer.getElementsByClassName("waist-measurement-medium")[0].innerHTML = "8.6 - 9.0";
			chartContainer.getElementsByClassName("waist-measurement-large")[0].innerHTML = "9.0 - 9.4";
			chartContainer.getElementsByClassName("waist-measurement-xlarge")[0].innerHTML = "9.4 - 9.8";
			chartContainer.getElementsByClassName("waist-measurement-xxlarge")[0].innerHTML = "9.8 - 10.2";
		} else {
			chartContainer.getElementsByClassName("chest-measurement-xsmall")[0].innerHTML = "74 - 78";
			chartContainer.getElementsByClassName("chest-measurement-small")[0].innerHTML = "78 - 82";
			chartContainer.getElementsByClassName("chest-measurement-medium")[0].innerHTML = "82 - 86";
			chartContainer.getElementsByClassName("chest-measurement-large")[0].innerHTML = "86 - 90";
			chartContainer.getElementsByClassName("chest-measurement-xlarge")[0].innerHTML = "90 - 94";
			chartContainer.getElementsByClassName("chest-measurement-xxlarge")[0].innerHTML = "94 - 98";

			chartContainer.getElementsByClassName("waist-measurement-xsmall")[0].innerHTML = "20 - 21";
			chartContainer.getElementsByClassName("waist-measurement-small")[0].innerHTML = "21 - 22";
			chartContainer.getElementsByClassName("waist-measurement-medium")[0].innerHTML = "22 - 23";
			chartContainer.getElementsByClassName("waist-measurement-large")[0].innerHTML = "23 - 24";
			chartContainer.getElementsByClassName("waist-measurement-xlarge")[0].innerHTML = "25 - 26";
			chartContainer.getElementsByClassName("waist-measurement-xxlarge")[0].innerHTML = "26 - 28";
		}
    // womens jersey sizing
	} else if(chartContainer.classList.contains("womens-jersey")){
		if(attribute.innerText == "IN") {
            chartContainer.getElementsByClassName("chest-measurement-xsmall")[0].innerHTML = "30.7 - 32.3";
			chartContainer.getElementsByClassName("chest-measurement-small")[0].innerHTML = "32.3 - 33.9";
			chartContainer.getElementsByClassName("chest-measurement-medium")[0].innerHTML = "33.9 - 35.4";
			chartContainer.getElementsByClassName("chest-measurement-large")[0].innerHTML = "35.4 - 37";
			chartContainer.getElementsByClassName("chest-measurement-xlarge")[0].innerHTML = "37 - 39.4";

			chartContainer.getElementsByClassName("waist-measurement-xsmall")[0].innerHTML = "29.1 - 30.7";
			chartContainer.getElementsByClassName("waist-measurement-small")[0].innerHTML = "30.7 - 32";
			chartContainer.getElementsByClassName("waist-measurement-medium")[0].innerHTML = "32 - 33.8";
			chartContainer.getElementsByClassName("waist-measurement-large")[0].innerHTML = "33.8 - 35.4";
			chartContainer.getElementsByClassName("waist-measurement-xlarge")[0].innerHTML = "35.4 - 38.6";
		} else {
			chartContainer.getElementsByClassName("chest-measurement-xsmall")[0].innerHTML = "78 - 82";
			chartContainer.getElementsByClassName("chest-measurement-small")[0].innerHTML = "82 - 86";
			chartContainer.getElementsByClassName("chest-measurement-medium")[0].innerHTML = "86 - 90";
			chartContainer.getElementsByClassName("chest-measurement-large")[0].innerHTML = "90 - 94";
			chartContainer.getElementsByClassName("chest-measurement-xlarge")[0].innerHTML = "94 - 100";

			chartContainer.getElementsByClassName("waist-measurement-xsmall")[0].innerHTML = "60 - 64";
			chartContainer.getElementsByClassName("waist-measurement-small")[0].innerHTML = "64 - 68";
			chartContainer.getElementsByClassName("waist-measurement-medium")[0].innerHTML = "68 - 72";
			chartContainer.getElementsByClassName("waist-measurement-large")[0].innerHTML = "72 - 76";
			chartContainer.getElementsByClassName("waist-measurement-xlarge")[0].innerHTML = "76 - 80";
		}	 	
    // womens bibs sizing
	} else if(chartContainer.classList.contains("womens-bibs")){
		if(attribute.innerText == "IN") {
			chartContainer.getElementsByClassName("chest-measurement-xsmall")[0].innerHTML = "29.1 - 30.7";
			chartContainer.getElementsByClassName("chest-measurement-small")[0].innerHTML = "30.7 - 32";
			chartContainer.getElementsByClassName("chest-measurement-medium")[0].innerHTML = "32 - 33.8";
			chartContainer.getElementsByClassName("chest-measurement-large")[0].innerHTML = "33.8 - 35.4";
			chartContainer.getElementsByClassName("chest-measurement-xlarge")[0].innerHTML = "35.4 - 38.6";

			chartContainer.getElementsByClassName("waist-measurement-xsmall")[0].innerHTML = "6.3";
			chartContainer.getElementsByClassName("waist-measurement-small")[0].innerHTML = "6.7";
			chartContainer.getElementsByClassName("waist-measurement-medium")[0].innerHTML = "7.1";
			chartContainer.getElementsByClassName("waist-measurement-large")[0].innerHTML = "7.5";
			chartContainer.getElementsByClassName("waist-measurement-xlarge")[0].innerHTML = "7.7";
		} else {
			chartContainer.getElementsByClassName("chest-measurement-xsmall")[0].innerHTML = "60 - 64";
			chartContainer.getElementsByClassName("chest-measurement-small")[0].innerHTML = "64 - 68";
			chartContainer.getElementsByClassName("chest-measurement-medium")[0].innerHTML = "68 - 72";
			chartContainer.getElementsByClassName("chest-measurement-large")[0].innerHTML = "72 - 76";
			chartContainer.getElementsByClassName("chest-measurement-xlarge")[0].innerHTML = "76 - 80";

			chartContainer.getElementsByClassName("waist-measurement-xsmall")[0].innerHTML = "16";
			chartContainer.getElementsByClassName("waist-measurement-small")[0].innerHTML = "17";
			chartContainer.getElementsByClassName("waist-measurement-medium")[0].innerHTML = "18";
			chartContainer.getElementsByClassName("waist-measurement-large")[0].innerHTML = "19";
			chartContainer.getElementsByClassName("waist-measurement-xlarge")[0].innerHTML = "19.5";
		}
    }
}

/***** END // SIZE CHART MEASUREMENT SWITCH TOGGLE *****/ 



/***** CART TERMS AND CONDITIONS CHECKBOX *****/ 
//adds check box users must press when proceeding from cart to checkout 
// $(document).ready(function() {
//     $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
//     if ($('#agree').is(':checked')) {
//       $(this).submit();
//     }
//     else {
//       alert("You must agree with the terms and conditions of sales to check out.");
//       return false;
//     }
//   });
// });
/***** END // CART TERMS AND CONDITIONS CHECKBOX *****/ 
